import VideoCard from "@/components/VideoCard";

const VIDEOS = [
  {
    title: "Pratica del Mattino",
    vimeoId: "1055081696",
    posterUrl: "https://res.cloudinary.com/dbtllbnr1/image/upload/v1782292392/thumb_2_jwwdbc.jpg",
    description: "Attiva la tua energia vitale per iniziare la giornata in armonia.",
    accent: "#e07818",
    testid: "pratiche-card-mattino",
  },
  {
    title: "Pratica della Sera",
    vimeoId: "1055084301",
    posterUrl: "https://res.cloudinary.com/dbtllbnr1/image/upload/v1782292499/thumb_l7rt5l.jpg",
    description: "Rilascia le tensioni del giorno e prepara il corpo al riposo.",
    accent: "#1535a0",
    testid: "pratiche-card-sera",
  },
  {
    title: "Preghiera a Madre Terra",
    vimeoId: "1055082479",
    posterUrl: "https://res.cloudinary.com/dbtllbnr1/image/upload/v1782292464/thumb_3_nwgcv4.jpg",
    description: "Connettiti alla forza della terra e ricevi la sua saggezza ancestrale.",
    accent: "#2e9020",
    testid: "pratiche-card-madre-terra",
  },
  {
    title: "Meditazione Sciamanica per uscire dalle difficoltà",
    vimeoId: "1055078713",
    posterUrl: "https://res.cloudinary.com/dbtllbnr1/image/upload/f_auto,q_auto/thumb_1_eyakxi",
    description: "Tecnica guidata per ritrovare il centro nei momenti difficili.",
    accent: "#941a7c",
    testid: "pratiche-card-meditazione",
  },
];

export default function Pratiche() {
  return (
    <div className="px-6 pt-10" data-testid="pratiche-screen">
      <header className="mb-7">
        <p className="font-body text-[11px] tracking-[0.4em] uppercase text-[#e07818]">
          Sezione
        </p>
        <h1 className="font-serif-display text-[40px] leading-[1.05] tracking-tight text-[#2e2820] mt-2">
          Pratiche <span className="italic">Gratuite</span>
        </h1>
        <p className="font-body text-base text-[#7a6f65] leading-relaxed mt-3">
          Quattro pratiche guidate per accompagnarti nel quotidiano — dal risveglio
          al riposo.
        </p>
      </header>

      <section className="flex flex-col gap-5">
        {VIDEOS.map((v) => (
          <VideoCard key={v.vimeoId} {...v} />
        ))}
      </section>
    </div>
  );
}
